import React, {useState} from "react";
import Burger from '../Hamburger.js'
import MobileNavBar from '../MobileNavBar.js'
import '../Desktop.css'

import Book from '../../Images/Design/PenguinBooks/TheSecretWorldofBriarRose.jpg'
import Cover from '../../Images/Design/TheSecretWorldofBriarRose_Bookcover.jpg'
import Case from '../../Images/Design/PenguinBooks/TheSecretWorldofBriarRose_Case.jpg'
import Jacket from '../../Images/Design/PenguinBooks/TheSecretWorldofBriarRose_jacket.jpg'



function SecretWorldofBriarRose(){
	const [open, setOpen] = useState(false);

	return(
		<div class="page">
		    <div class="designContentPageBook">
		    	<div className="mobileNav">
					<Burger open={open} setOpen={setOpen}/>
					<MobileNavBar open={open} setOpen={setOpen}/>
				</div>
		        <div class="contentHMH">
		            <img class="contentImage" src={Book} />
		            <p class="contentTextHMHTitle">The Secret World of Briar Rose</p>
		            <p class="contentTextHMH">Penguin Young Readers</p>
		            <p class="contentTextHMH ItalicText" > Art direction, design</p>
		            <br />
		            <p class="contentTextHMH2 ItalicText" >Illustration by Enid Din</p>
		        </div>
				<br />
				<img class="contentImage" src={Jacket} />

				<img class="contentImage" src={Case} />
		    </div>
		</div>
	)
}

export default SecretWorldofBriarRose